import React, { useEffect, useState } from 'react'
import AirportSelector from './airports.component';
import CountrySelector from './countries.component';
import styled from 'styled-components'
import { getLocation } from '../../api/api-wrapper';
import TerminalList from './terminal-list.component';

const ParentDiv = styled.div`
  & {
    width: 100%;
  }
`;

const ChildDiv = styled.div`
  & {
    display: inline-block;
    vertical-align: text-top;
    margin: 0 auto;
    padding: 0.5rem 1rem 0.5rem 1rem;
  }
`;


export default function Terminals(props: any) {
    let [ country, setCountry ] = useState<string>();
    let [ airport, setAirport ] = useState<string>();
    useEffect(() => {
        async function loadDefaultCountry() {
            if (!country) {
                let defaultCountry = await getLocation();
                setCountry(defaultCountry.alpha_2);
            }
        }
        loadDefaultCountry();
    }, [country, airport])
    function updateCountry(country: string) {
        setCountry(country);
    }
    function updateAirport(airport: string) {
        setAirport(airport);
    }
    return (

        <div className="page-wrapper">
            <div className="page-inner">
                <div>
                    <h3>Terminals</h3>
                        <ParentDiv>
                            <ChildDiv>
                                <CountrySelector
                                    defaultCountry={country as string}
                                    onSelectionUpdate={updateCountry}
                                ></CountrySelector>
                            </ChildDiv>
                            <ChildDiv>
                                <AirportSelector
                                    country={country as string}
                                    onSelectionUpdate={updateAirport}
                                ></AirportSelector>
                            </ChildDiv>
                        </ParentDiv>
                    <div>
                    </div>
                    <TerminalList
                        airport={airport as string}
                    />
                </div>
            </div>
        </div>
    )

}
